import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { isCurrentUserProfileOwner } from '../../../selectors/users';

import { getModuleData, getModuleMeta } from '../../../selectors/modules';
export default connect((state: AppState, ownProps) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const deviation = getDeviationById(state, moduleData.deviation);
  return {
    ...moduleData,
    isNewlyAddedModule: getModuleMeta(state, ownProps.moduleId).isNewlyAdded,
    deviation,
    isOwner: isCurrentUserProfileOwner(state),
  };
});
